import React, { useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import WMICHOCustomCoverageTerm from '../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTerm';
import WMICHOContentsOffPremisesCovDetailView from './WMICHOContentsOffPremisesCovDetailView/WMICHOContentsOffPremisesCovDetailView';

import messages from './WMICHOContentsOffPremisesCov.messages';
import metadata from './WMICHOContentsOffPremisesCov.metadata.json5';

function WMICHOContentsOffPremisesCov(props) {
    const {
        id,
        dwellingVM,
        path,
        onUpdateJobAndCoverage,
        readOnly,
        onValidationChange: parentOnValidate,
        showErrors: parentShowErrors,
    } = props;
    const translator = useTranslator();

    const updateJobAndCoverage = async () => {
        const items = dwellingVM?.contentsOffPremisesCovItems?.value || [];
        const limitAmount = items.reduce((sum, item) => sum + item.limitAmount, 0);
        await onUpdateJobAndCoverage(limitAmount, `${path}.terms[0].directValue`);
    };

    const minimumContentsOffPremisesValidCheck = useCallback(
        () => dwellingVM?.contentsOffPremisesCovItems?.value?.length > 0,
        [dwellingVM]
    );

    const overrideProps = {
        oneLocationRequiredMessage: {
            visible: !minimumContentsOffPremisesValidCheck(),
        },
        contentsOffPremisesCoverageList: {
            id,
            addButtonLabel: messages.addLocationButton,
            coverageItemsVM: dwellingVM?.contentsOffPremisesCovItems,
            detailViewComponent: WMICHOContentsOffPremisesCovDetailView,
            dtoType:
                // eslint-disable-next-line no-secrets/no-secrets
                'wmic.edge.ca.capabilities.policyjob.lob.homeownersHOE.coverables.dto.dwelling.ContentsOffPremisesCovItemDTO_WMIC',
            dwellingVM,
            onComponentValidation: minimumContentsOffPremisesValidCheck,
            onValidationChange: parentOnValidate,
            onUpdateJobAndCoverage: updateJobAndCoverage,
            readOnly,
            showErrors: parentShowErrors,
            VMData: [
                {
                    headerText: translator(messages.location),
                    path: 'location',
                },
                {
                    headerText: translator(messages.limit),
                    path: 'limitAmount',
                },
            ],
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICHOCustomCoverageTerm,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={parentOnValidate}
            showErrors={parentShowErrors}
        />
    );
}

export default WMICHOContentsOffPremisesCov;
